import React, { useState } from 'react';
import '../../../styles/Modal.css';

const AdditionalInfoModal = ({ isOpen, onClose, onConfirm }) => {
    const [info, setInfo] = useState("");

    if (!isOpen) return null;

    const handleConfirm = () => {
        onConfirm(info);
        setInfo(""); // Reset the input after confirming
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h2>Dodatkowe informacje</h2>
                <textarea
                    id="additional-info"
                    value={info}
                    onChange={(e) => setInfo(e.target.value)}
                    placeholder="Tutaj wpisz dodatkowe informacje...
                    Pozostaw puste, jeśli nie masz nic do dodania."
                    rows="4"
                    style={{ width: "100%" }}
                />
                <div className="modal-buttons">
                    <button className="cancel-btn" onClick={onClose}>
                        Anuluj
                    </button>
                    <button className="save-btn" onClick={handleConfirm}>
                        Zarezerwuj
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AdditionalInfoModal;